module.exports = __webpack_public_path__ + "static/media/DSCF2464.6b115287.jpg";